import React, { useEffect } from "react";
import { Button, Flex, Spinner, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import SectionHeader from "../../components/SectionHeader";
import StoresList from "./StoresList";
import { getStores } from '../../actions/storesActions'
import { useDispatch, useSelector } from "react-redux";
import withNavElements from "../../components/withNavElements";

const StoresPage = ({history}) => {
  const dispatch = useDispatch();
  const { loading, stores: storesList } = useSelector(state => state.storesList)
  const { userInfo } = useSelector(state => state.userLogin)

  useEffect(() => {
    const fetchStores = async () => {
      dispatch(getStores())
    };
    fetchStores();
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Mis Tiendas - Skyshops</title>
      </Helmet>
      <Flex
        flex={1}
        minH="300px"
        h="100%"
        mt="70px"
        py="40px"
        px={{ base: 0, md: "20px" }}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Text fontSize="1.5em" fontWeight="400">
          Mis Tiendas
        </Text>
        <Flex
          mt="40px"
          w="100%"
          pt="50px"
          pb='100px'
          px={{ base: "40px", md: "40px" }}
          flex={1}
          minH="100%"
          bg="gray.100"
          borderRadius="10px"
          justifyContent="center"
          alignItems="center"
          flexDir={"column"}
        >
          {loading ? (
            <Flex
              flexDir={"column"}
              justifyContent="center"
              alignItems={"center"}
              w="100%"
            >
              <Text fontSize="1.2em" fontWeight="500" mb="20px">
                Obteniendo tus tiendas...
              </Text>
              <Spinner />
            </Flex>
          ) : (
            <>
              <SectionHeader
                title="Bienvenido a Skyshops"
                description={
                  storesList?.length > 0
                    ? "Aquí puedes ver todas tus tiendas"
                    : "Parece que aún no tienes tiendas creadas"
                }
                justifyContent="center"
                alignItems="center"
                mb='0'
              />

              { userInfo.slots > storesList?.length ?
                <Text fontSize='.9em' mb='20px'>
                o <Link style={{textDecoration: "underline"}} to="/admin/new-store">crear una nueva</Link>
                </Text> : (
                  <Text fontSize='.9em' mb='20px'>
                    Has utilizado todos tus slots, puedes solicitar más
                  </Text>
                )
              }

              {storesList?.length > 0 ? (
                <Flex
                  w="100%"
                  flexWrap={"wrap"}
                  alignItems={"start"}
                  justifyContent="center"
                  pt='20px'
                >
                  <StoresList storesList={storesList}  history={history}/>
                </Flex>
              ) : (
                <Flex w="100%" alignItems={"center"} justifyContent="center">
                  <Link to={`/admin/new-store`}>
                    <Button colorScheme="blue" size="lg" mt="10px">
                      ¡Crea una nueva! 🎉
                    </Button>
                  </Link>
                </Flex>
              )}
            </>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default withNavElements(StoresPage);
